

<div class="row"  style="width: 99%;"> 
  <div class="col-md-6 col-lg-6 col-sm-6">
  <app-ol-map class="map"
  
  (mapReady)="onMapReady($event)"
  ></app-ol-map>
</div>
<div class="col-md-6 col-lg-6 col-sm-6">
 <app-tabs ></app-tabs>
</div>

<!-- <router-outlet></router-outlet> -->
</div>